import color from "../../../constants/color";

const style = {
  container: {
    px: "15px",
    py: 2,
    backgroundColor: "#F1F1F1",
    minHeight: "100vh",
  },
  headerContainer: {
    mb: 3,
  },
  title: {
    fontWeight: 600,
    fontSize: "24px",
    color: color.text,
    mb: 1,
  },
  subtitle: {
    fontSize: "15px",
    color: color.lightText,
  },
  section: {
    backgroundColor: "#fff",
    borderRadius: "12px",
    p: 3,
    mb: 2,
    boxShadow: "0px 2px 8px rgba(0, 0, 0, 0.05)",
  },
  sectionTitle: {
    fontWeight: 600,
    fontSize: "18px",
    color: color.text,
    mb: 2,
  },
  label: {
    fontSize: "15px",
    fontWeight: 500,
    color: color.text,
    mb: 1,
  },
  input: {
    "& .MuiOutlinedInput-root": {
      borderRadius: "8px",
      backgroundColor: "#F5F5F5",
      "& fieldset": {
        borderColor: color.lightGray,
      },
      "&.Mui-disabled": {
        backgroundColor: "#F5F5F5",
      },
    },
    "& .MuiInputBase-input": {
      fontSize: "15px",
      fontWeight: "400",
      padding: "10px 14px",
      cursor: "not-allowed",
    },
    "& .MuiInputBase-input.Mui-disabled": {
      WebkitTextFillColor: "#000000",
      color: "#000000",
      cursor: "not-allowed",
    },
  },
  select: {
    borderRadius: "8px",
    backgroundColor: "#F5F5F5",
    "& .MuiOutlinedInput-notchedOutline": {
      borderColor: color.lightGray,
    },
    "&.Mui-disabled": {
      backgroundColor: "#F5F5F5",
      "& .MuiSelect-select": {
        WebkitTextFillColor: "#000000",
        color: "#000000",
      },
    },
    "& .MuiSelect-select": {
      fontSize: "15px",
      fontWeight: "400",
      padding: "10px 14px",
      "&.Mui-disabled": {
        WebkitTextFillColor: "#000000",
        color: "#000000",
      },
    },
    "& .MuiSelect-icon.Mui-disabled": {
      color: "#000000",
    },
  },
  datePicker: {
    width: "100%",
    "& .MuiOutlinedInput-root": {
      borderRadius: "8px",
      backgroundColor: "#F5F5F5",
      "&.Mui-disabled": {
        backgroundColor: "#F5F5F5",
        "& .MuiInputBase-input": {
          WebkitTextFillColor: "#000000",
          color: "#000000",
        },
      },
    },
    "& .MuiInputBase-input.Mui-disabled": {
      WebkitTextFillColor: "#000000",
      color: "#000000",
    },
    "& .MuiInputAdornment-root .MuiIconButton-root.Mui-disabled": {
      color: "#000000",
    },
  },
  infoText: {
    fontSize: "12px",
    color: color.lightText,
    fontStyle: "italic",
    mt: 1,
  },
  tableContainer: {
    boxShadow: "none",
    borderRadius: "8px",
    border: `1px solid ${color.lightGray}`,
  },
  tableHeaderCell: {
    fontWeight: 600,
    fontSize: "13px",
    color: color.lightText,
    borderBottom: `1px solid ${color.lightGray}`,
  },
  tableRow: {
    "&:hover": {
      backgroundColor: "#FAFAFA",
    },
  },
  tableCell: {
    fontSize: "13px",
    color: color.text,
    borderBottom: `1px solid ${color.lightGray}`,
  },
  emptyCell: {
    py: 3,
    color: color.lightText,
  },
  errorText: {
    fontSize: "12px",
    color: color.red,
    mt: 0.5,
    ml: 1.75,
  },
  buttonContainer: {
    display: "flex",
    justifyContent: "flex-end",
    gap: 2,
    mt: 3,
  },
  submitButton: {
    backgroundColor: color.primary,
    color: "#fff",
    borderRadius: "50px",
    textTransform: "none",
    px: 4,
    py: 1,
    fontWeight: 500,
    boxShadow: "0px 2px 4px rgba(0, 0, 0, 0.15)",
    "&:hover": {
      backgroundColor: "#228A3A",
      boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.2)",
    },
  },
  cancelButton: {
    borderRadius: "50px",
    textTransform: "none",
    px: 4,
    py: 1,
    backgroundColor: "#808080",
    color: "#fff",
    "&:hover": {
      backgroundColor: "#6B6B6B",
    },
  },
};

export default style;
